
// 此页面为单独解析页面
import { onMounted, nextTick, watch, ref, computed, onBeforeMount, reactive } from 'vue'
import { playVideo } from '@/utils/nativeFn'
import { queryVideoInfo } from '@/api/aio'
export default {
  name: 'QueAnalysisTile',
  props: {
    questionData: {
      type: Object,
      default: () => ({})
    },
    submitQestionMap: {
      type: Object,
      default: () => ({})
    },
    questionIndex: {
      type: Number,
      default: 0
    },
    currentIndex: {
      type: Number,
      default: -1
    },
    xesEvent: {
      type: Function,
      default: () => {}
    }
  },
  emits: ['xesEvent'],
  setup(props, { emit }) {
    const loadedVedio = ref(false)
    const isRight = ref(props.questionData?.isRight)
    const queId = props.questionData?.list?.queId || ''
    const playVideoParam = reactive({ content_id: '' })
    const videoImg = ref('')
    let clickedVideoPlay = false
    const currentIndex = computed(() => props.currentIndex)
    // const myAnswer = computed(() => {
    //   let _myAnswer = null
    //   if (props.questionData?.list?.childList?.length) {
    //     _myAnswer = props.questionData.list.childList.map((item) => {
    //       return props.submitQestionMap?.[item.queId]?.data || []
    //     })
    //   } else {
    //     _myAnswer = [[...(props.submitQestionMap?.[props.questionData?.list?.queId]?.data || [])]]
    //   }
    //   return _myAnswer
    // })
    watch(currentIndex, (val) => {
      if (!loadedVedio.value && val >= 0 && val === props.questionIndex) {
        getVideoInfo()
        loadedVedio.value = true
      }
    })
    onBeforeMount(() => {
      if (
        !loadedVedio.value &&
        currentIndex.value >= 0 &&
        currentIndex.value === props.questionIndex
      ) {
        getVideoInfo()
        loadedVedio.value = true
      }
    })
    onMounted(() => {
      window['TalqsInteraction'].toggleInteraction([{ queId, rectifyState: [0] }])
      renderQuestion()
    })
    // 渲染题目信息
    const renderQuestion = () => {
      let data = props.questionData
      let questionIndex = props.questionIndex
      nextTick(() => {
        let questionAnalysisDom: any = document.getElementById(`questionAnalysis_${questionIndex}`)
        let questionAnswerDom: any = document.getElementById(`questionAnswer_${questionIndex}`)
        try {
          questionAnalysisDom.innerHTML = (window as any).TalqsTemplate.renderPartialComponent(
            'questionAnalyze',
            data.list,
            { hideDifficulty: true, hideSource: true, hideCamera: true, analyzeVersion: 2 }
          )
          questionAnswerDom.innerHTML = (window as any).TalqsTemplate.renderPartialComponent(
            'questionAnswer',
            data.list,
            { hideDifficulty: true, hideSource: true, hideCamera: true }
          )
          ;(window as any).MathJax.Hub.Queue([
            'Typeset',
            (window as any).MathJax.Hub,
            questionAnalysisDom
          ])
          ;(window as any).MathJax.Hub.Queue([
            'Typeset',
            (window as any).MathJax.Hub,
            questionAnswerDom
          ])
          ;(window as any).MathJax.Hub.Queue([
            'Typeset',
            (window as any).MathJax.Hub,
            document.getElementById(`myAnswer_${questionIndex}`)
          ])
          ;(window as any).TalqsTemplate.autoLayout()
        } catch (e) {
          console.log('error', e)
        }
      })
    }

    const getVideoInfo = () => {
      queryVideoInfo({ nry_question_id: queId })
        .then((res) => {
          if (res.data.code == 0) {
            const data = res.data.data
            videoImg.value = data?.good_img || ''
            Object.assign(playVideoParam, {
              resource_vod_src: data.resource_vod_src,
              resource_src: data.resource_src,
              content_id: data.unionid,
              sn: data?.sn || '',
              source_list: data?.source_list || [],
              is_dot: data.is_dot,
              title: data.title
            })
          }
        })
        .catch((err) => {})
    }
    const doPlayVideo = () => {
      if (clickedVideoPlay) return
      clickedVideoPlay = true
      playVideo(playVideoParam, (res) => {
        console.log('视频播放中')
        clickedVideoPlay = false
      })
      emit('xesEvent', { play_vedio: 'play_vedio' })
      let timer = setTimeout(() => {
        clickedVideoPlay = false
        clearTimeout(timer)
      }, 300)
    }
    return { queId, isRight, playVideoParam, videoImg, doPlayVideo }
  }
}
